import { createFileRoute } from "@tanstack/react-router";
import { TeammatePage } from "../../../components/teammates/teammate-page";

/** One teammate's page: what waits on people, its playbooks, what it did (Paper TM4b, ENG-1038). */
export const Route = createFileRoute("/_authenticated/_workspace/teammates/$teammateId")({
  component: function TeammateRoute() {
    const { teammateId } = Route.useParams();
    return <TeammatePage teammateId={teammateId} />;
  },
});
